import type { ReactNode } from 'react';
import { AppErrorBoundary } from '../app-error-boundary';
import type { AppRuntime } from '../runtime';
import { I18nProvider } from './i18n-provider';
import { QueryProvider } from './query-provider';
import { RuntimeProvider } from './runtime-provider';
import { SessionProvider } from './session-provider';
import { ThemeProvider } from './theme-provider';

/**
 * The provider stack: Runtime > I18n > Theme > error boundary > Query > Session > (Router). The
 * error boundary sits inside the theme so its page is translated and styled.
 */
export function AppProviders({ runtime, children }: { runtime: AppRuntime; children?: ReactNode }) {
  return (
    <RuntimeProvider runtime={runtime}>
      <I18nProvider>
        <ThemeProvider>
          <AppErrorBoundary>
            <QueryProvider>
              <SessionProvider>{children}</SessionProvider>
            </QueryProvider>
          </AppErrorBoundary>
        </ThemeProvider>
      </I18nProvider>
    </RuntimeProvider>
  );
}
